import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const CREDIT_MANAGEMENT_SIDEBAR_DATA = [
  {
    header: 'CREDIT MANAGEMENT',
    tabs: [
      {
        tabName: 'Manage Credit',
        to: '/credit-management/manage-credit/',
        subject: PERMISSION_SUBJECTS.userCredit,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default CREDIT_MANAGEMENT_SIDEBAR_DATA;
